var queryString = require('query-string'),
    docCookies = require('doc-cookies');

/**
 * Checks request parameters for containing passed parameters names and sets cookies with request parameters values.
 *
 * @param params {Array} of names of request parameters.
 * @param [windowLocation] {Object} - optional, window.location for example. DI for unit testing purposes.
 * @private
 */
function _setSelfValues(params, windowLocation) {
    var _windowLocation = windowLocation || window.location;
    var reqParams = queryString.parse(_windowLocation.search);

    if (!Array.isArray(params)) {
        throw new TypeError('Params must be array');
    }

    params.forEach(function (param) {
        if (reqParams[param]) {
            if (reqParams[param].length > 0) {
                docCookies.setItem(param, reqParams[param]);
            }
        }
    });
}

module.exports = {
    setSelfValues: _setSelfValues
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/req-params-to-cookie/req-params-to-cookie.js
// module id = 326
// module chunks = 36